import React, { useCallback, useEffect, useState } from 'react'
import Select from 'react-select'
import './CompetitionFilter.scss'
import { useTranslation } from 'react-i18next'

const CompetitionFilter = ({
  competitions,
  selectedCompetition,
  onCompetitionChange,
  onSearch,
  fetching
}) => {
  const [debouncedValue, setDebouncedValue] = useState('')
  const [isTyping, setIsTyping] = useState(false)

  const options = [
    ...(competitions && competitions.length > 0
      ? competitions.map(competition => ({
          value: competition.id,
          label: competition.title
        }))
      : [{ value: 'none', label: 'None' }])
  ]

  const handleChange = selectedOption => {
    if (selectedOption) {
      onCompetitionChange(selectedOption)
    } else {
      onSearch('')
    }
  }

  const handleInputChange = inputValue => {
    setDebouncedValue(inputValue)
    setIsTyping(inputValue.length > 0)
  }

  const debouncedSearch = useCallback(
    (() => {
      let timeoutId
      return value => {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => {
          if (onSearch) {
            onSearch(value)
          }
        }, 300)
      }
    })(),
    [onSearch]
  )

  useEffect(() => {
    debouncedSearch(debouncedValue)
  }, [debouncedValue, debouncedSearch])
  const { t } = useTranslation()
  return (
    <div className="competition-filter">
      <div className="competition-filter__label">
        {t('v4:competition_filter')}:
      </div>
      <div className="competition-filter__select">
        <Select
          value={selectedCompetition}
          onChange={handleChange}
          onInputChange={handleInputChange}
          options={options}
          placeholder={t('v5:select_a_competition')}
          isLoading={fetching}
          isClearable={isTyping}
          isSearchable
          className="competition-select"
          classNamePrefix="competition-select"
        />
      </div>
    </div>
  )
}

export default CompetitionFilter
